<div
  id="device-init-view"
  class="matp-table-container tw-max-h-[calc(100vh_-_200px)]"
>
  <div class="tw-text-base tw-mb-3">
    デバイスを検索するか、以下のメニューから登録を行ってください。
  </div>
  <div class="matp-table-actions-area">
    <div class="tw-flex" id="init-view-style">
      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="confirmed.emit()"
      >
        <mat-icon>visibility</mat-icon>
        <span>登録確認</span>
      </button>

      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="created.emit()"
      >
        <mat-icon>add</mat-icon>
        <span>新規登録</span>
      </button>

      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="imported.emit()"
      >
        <mat-icon>file_upload</mat-icon>
        <span>インポート</span>
      </button>
    </div>
  </div>
</div>

<div
  id="device-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_200px)]"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actions">
      <button
        mat-raised-button
        id="filter-clear-btn"
        class="tw-mr-2"
        (click)="clearFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
        <span>クリア</span>
      </button>
      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="confirmed.emit()"
      >
        <mat-icon>visibility</mat-icon>
        <span>登録確認</span>
      </button>

      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="created.emit()"
      >
        <mat-icon>add</mat-icon>
        <span>新規登録</span>
      </button>

      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="imported.emit()"
      >
        <mat-icon>file_upload</mat-icon>
        <span>インポート</span>
      </button>

      <button
        mat-raised-button
        id="delete-all-btn"
        color="warn"
        class="tw-mr-2"
        (click)="deleteAll()"
        [disabled]="readonly || !selection.hasValue()"
      >
        <mat-icon>delete</mat-icon>
        <span>一括削除</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
      id="device-table"
      class="matp-table"
    >
      <!-- チェックボックス -->
      <ng-container matColumnDef="checkbox">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="matp-table-header-middle !tw-min-w-min"
        >
          <mat-checkbox
            color="primary"
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element) : null"
            [checked]="selection.isSelected(element)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- テナント -->
      <ng-container matColumnDef="tenant">
        <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
          <div mat-sort-header class="matp-table-header-title">テナント</div>
          <mat-form-field
            appearance="outline"
            class="matp-form-field-slim tw-bg-white"
          >
            <mat-select (click)="$event.stopPropagation()">
              @for (tenant of tenantList; track tenant) {
                <mat-option [value]="tenant">{{ tenant }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td name="tenant" mat-cell *matCellDef="let element">
          {{ element.tenant }}
        </td>
      </ng-container>

      <!-- シリアル番号 -->
      <ng-container matColumnDef="serialNo">
        <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
          <div mat-sort-header class="tw-flex matp-table-header-title">
            シリアル番号
          </div>
          <mat-form-field
            appearance="outline"
            class="matp-form-field-slim tw-bg-white"
          >
            <input
              matInput
              appAutocompleteOff
              type="text"
              name="serialNo"
              [(ngModel)]="serialNoKeyword"
              (keyup)="applyFilter()"
            />
            <button
              matSuffix
              mat-icon-button
              id="serialno-filter-clear-btn"
              (click)="clearSerialNoFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="serialNo" mat-cell *matCellDef="let element">
          {{ element.serialNo }}
        </td>
      </ng-container>

      <!-- デバイス種類 -->
      <ng-container matColumnDef="deviceTypeId">
        <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
          <div mat-sort-header class="tw-flex matp-table-header-title">
            デバイス種類
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              [(ngModel)]="selectedDeviceType"
              name="deviceTypeFilter"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              @for (displayName of deviceTypeDisplayNames; track displayName) {
                <mat-option [value]="displayName">{{ displayName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td name="deviceTypeId" mat-cell *matCellDef="let element">
          {{ element.deviceTypeDisplayName }}
        </td>
      </ng-container>

      <!-- 最終通信日時 -->
      <ng-container matColumnDef="lastCommunicationAt">
        <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
          <div mat-sort-header class="tw-flex matp-table-header-title">
            最終更新日時
          </div>
          <mat-form-field
            appearance="outline"
            class="matp-form-field-slim tw-bg-white"
          >
            <input
              matInput
              appAutocompleteOff
              type="text"
              name="lastCommunicationAt"
              [(ngModel)]="lastCommunicationAtKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="lastcommunicationatkeyword-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearLastCommunicationAtFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="lastCommunicationAt" mat-cell *matCellDef="let element">
          {{ element.lastCommunicationAt | date: " yyyy/MM/dd HH:mm:ss" }}
        </td>
      </ng-container>

      <!-- テナント名 -->
      <ng-container matColumnDef="tenantName">
        <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
          <div mat-sort-header class="tw-flex matp-table-header-title">
            テナント名
          </div>
          <mat-form-field
            appearance="outline"
            class="matp-form-field-slim tw-bg-white"
          >
            <input
              name="tenantName"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="tenantNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="tenantname-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearTenantNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="tenantName" mat-cell *matCellDef="let element">
          {{ element.tenantName }}
        </td>
      </ng-container>

      <!-- テナントID -->
      <ng-container matColumnDef="tenantId">
        <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
          <div mat-sort-header class="tw-flex matp-table-header-title">
            テナントID
          </div>
          <mat-form-field
            appearance="outline"
            class="matp-form-field-slim tw-bg-white"
          >
            <input
              name="tenantId"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="tenantIdKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="tenantid-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearTenantIdFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="tenantId" mat-cell *matCellDef="let element">
          {{ element.tenantId }}
        </td>
      </ng-container>

      <!-- 契約開始日 -->
      <ng-container matColumnDef="contractStartedAt">
        <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
          <div
            mat-sort-header
            class="tw-flex matp-table-header-title tw-text-nowrap"
          >
            契約開始日
          </div>
          <mat-form-field
            appearance="outline"
            class="matp-form-field-slim tw-bg-white"
          >
            <input
              name="contractStartedAt"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="contractStartedAtKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="contractstartedat-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearContractStartedAtFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="contractStartedAt" mat-cell *matCellDef="let element">
          {{ element.contractStartedAt | date: "yyyy/MM/dd" }}
        </td>
      </ng-container>

      <!-- 契約期限 -->
      <ng-container matColumnDef="expiredAt">
        <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
          <div
            mat-sort-header
            class="tw-flex matp-table-header-title tw-text-nowrap"
          >
            契約終了日
          </div>
          <mat-form-field
            appearance="outline"
            class="matp-form-field-slim tw-bg-white"
          >
            <input
              name="expiredAt"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="expiredAtKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="expiredat-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearExpiredAtFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="expiredAt" mat-cell *matCellDef="let element">
          {{ element.expiredAt | date: "yyyy/MM/dd" }}
        </td>
      </ng-container>

      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-32 tw-max-w-32">
          <div class="matp-table-header-title">操作</div>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-w-32">
          <button
            mat-stroked-button
            id="edit-btn"
            color="primary"
            (click)="updated.emit(element)"
          >
            <mat-icon>edit</mat-icon>
            <span>編集</span>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="device-table-paginator"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>
</div>
